import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import {
  RewardPointsResponse,
  RewardPointsRequest,
  pointsService,
} from '@aslanpay/portal-common-lib';

const useRewardPoints = ({
  onSuccess,
  onError,
}: UseMutationOptions<RewardPointsResponse, Error, RewardPointsRequest>) => {
  return useMutation<RewardPointsResponse, Error, RewardPointsRequest>(
    ({
      individualIds,
      transactionReason,
      pointsAmount,
      notes,
      companyId,
      referralId,
    }: RewardPointsRequest) =>
      pointsService.rewardPoints({
        individualIds,
        transactionReason,
        pointsAmount,
        notes,
        companyId,
        referralId,
      }),
    { onSuccess, onError }
  );
};

export default useRewardPoints;
